import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import FollowUpsListModel from "../../models/follow-ups-list";

export default class FollowUpsListRepository extends BaseRepository {
  static modelClass = FollowUpsListModel;
  modelName = "follow-ups-list";

  async query({ actionItemId }) {
    if (actionItemId) {
      return await super.query({
        urlPath: "actionable_items/" + actionItemId + "/forms",
      });
    }
  }
}
